/**
 * Comportamento comune delle pagine scheda (es. /brands/new, /variants/:id) sul "dove si torna".
 *
 *  - apertura normale (dalla propria lista): Annulla e Salva tornano alla lista, nello stato
 *    in cui era (listReturn);
 *  - apertura da un'altra pagina con `?from=<token>` (es. il "+" marca della scheda prodotto):
 *    Annulla e Salva tornano a quella pagina, e Salva le consegna `{ kind, id }` del dato
 *    creato o modificato, che la pagina di partenza usa per selezionarlo subito.
 *
 * Uso: `mixins: [childPage({ listPath: '/brands', kind: 'brand' })]`, poi nel template
 * `:back-label="backLabel" @back="back" @saved="saved"`.
 */
import { backToList } from './list/listReturn';
import { returnInfo, goBackWithResult } from './pageReturn';

// da dove si e' arrivati: letto in beforeRouteEnter, prima che la pagina nasca
let lastEntered = '';

export function childPage({ listPath, kind }) {
	return {
		beforeRouteEnter(to, from, next) {
			lastEntered = from.path;
			next();
		},
		data() {
			return {
				enteredFromPath: lastEntered,
				ret: returnInfo(this.$route),
			};
		},
		computed: {
			backLabel() {
				return this.ret ? this.ret.label : 'Torna alla lista';
			},
		},
		methods: {
			// da dove si e' arrivati, gia' disponibile nel data() della pagina (i dati del mixin li' non si vedono)
			pageEnteredFrom() {
				return lastEntered;
			},
			notify(color, text) {
				this.$store.dispatch('settings/updateSnackbar', { color, text, snackbar: true, mode: 'multi-line', timeout: 5000 });
			},
			leave(result = null) {
				if (this.ret) {
					goBackWithResult(this.$router, this.ret, this.enteredFromPath, result);
					return;
				}
				backToList(this.$router, listPath, this.enteredFromPath === listPath);
			},
			back() {
				this.leave();
			},
			saved(text, entity) {
				this.notify('success', text);
				const id = (entity && entity._id) || (this.$route.params && this.$route.params.id) || null;
				this.leave({ kind, id, entity: entity || null });
			},
			notFound(text) {
				this.notify('error', text || 'Elemento non trovato');
				this.leave();
			},
		},
	};
}
